import { defineMessages } from "react-intl";

export const messages = defineMessages({
  timeRange: {
    id: "ari.management.timeRange",
    defaultMessage: "Time range"
  },
  bulkUpdate: {
    id: "ari.management.bulkUpdate",
    defaultMessage: "Bulk update"
  },
  quickUpdate: {
    id: "ari.management.quickUpdate",
    defaultMessage: "Quick update"
  },
  quickUpdateBlock: {
    id: "ari.management.quickUpdateBlock",
    defaultMessage: "Block full day"
  },
  loading: {
    id: "ari.management.loading",
    defaultMessage: "Loading..."
  },
  backToCurrentDay: {
    id: "ari.management.backToCurrentDay",
    defaultMessage: "Back to current day"
  }
});